<ng-form #stepForm="ngForm">
  <div>
    @switch (loadStatus.busy) {
      @case (true) {
        <div class="center"
          >
          <i class="fs-10 icon-loading"></i>
        </div>
      }
      @case (false) {
        <div>
          <div class="flex flex-bottom flex-justify-between">
            <h3 class="h3">
              {{'Stores' | translate}}:
            </h3>
          </div>
          <radio-group name="storeId"
            [(ngModel)]="currentStoreId">
            @for (store of stores; track $index) {
              <radio class="w-12 p-l-4-s m-t-1 radio-top"
                [disabled]="saving"
                (click)="onClick()"
                [value]="store.id">
                <div class="p-l-1 p-l-2-s">
                  <span class="h5">{{store.data?.store_name}}</span>
                  <p>
                    {{getStoreAddress(store)}}
                  </p>
                </div>
              </radio>
            }
          </radio-group>
          <input-wrap>
          <input type="hidden"
            [(ngModel)]="currentStoreId"
            name="storeId"
            required>
        </input-wrap>
      </div>
    }
  }
</div>
</ng-form>